<script>
  import { format } from 'svelte-i18n';
  import { useNavigate } from 'svelte-navigator';
  import { Modal, ModalBody, ModalHeader } from '@sveltestrap/sveltestrap';

  import { BackgroundPreview } from '@client/pages/brandkit/components';

  import {
    colorBackground,
    colorPrimary,
    colorSecondary,
    colorTertiary,
    companyName,
    logoUrl
  } from '@client/stores/brand';
  import { loadNewBackgroundModalTemplates } from '@client/stores/virtual-background-templates';

  const navigate = useNavigate();

  export let show = false;

  $: brand = {
    colorBackground: $colorBackground,
    colorPrimary: $colorPrimary,
    colorSecondary: $colorSecondary,
    colorTertiary: $colorTertiary,
    companyName: $companyName,
    logoUrl: $logoUrl
  };

  $: previewTemplates = loadNewBackgroundModalTemplates(brand);

  const onSelect = async (template) => {
    navigate(`new/${template.id}`);
  };

  const toggle = () => {
    show = false;
  };
</script>

{#if show}
  <Modal class="modal-wizard" isOpen size="xl" fullscreen="lg" {...$$restProps}>
    <ModalHeader class="text-center" {toggle}>{$format('label.NEW_BACKGROUND_MODAL_HEADER')}</ModalHeader>

    <ModalBody style="min-height: 33vh; margin-bottom: 72px;">
      <p>{$format('label.NEW_BACKGROUND_MODAL_DESCRIPTION')}</p>

      <div class="background-templates">
        {#each previewTemplates as template, index}
          <div class="preview">
            <h4 class="text-capitalize">{template.name}</h4>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
              class="background-template"
              data-testid="background-template-{index}"
              role="button"
              tabindex="0"
              on:click={() => onSelect(template)}
            >
              <BackgroundPreview
                width={template.width}
                height={template.height}
                background={template.background}
                foreground={template.foreground}
                cells={template.cells}
              />
            </div>
          </div>
        {/each}
      </div>
    </ModalBody>
  </Modal>
{/if}

<style lang="scss" src="./new-background-modal.scss"></style>
